var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
export var RadarContext = React.createContext(null);
export var RadarProvider = RadarContext.Provider;
export var useRadar = function () {
  var context = React.useContext(RadarContext);
  return __assign({
    topicNodes: {},
    viewboxPresets: {}
  }, context);
};